import { ChangeEvent } from 'react';
import clsx from 'clsx';

import CarouselWrapper from '@atom/components/common/photoCarousel/CarouselWrapper';
import { DatePicker } from '@atom/mui';
import { FormFieldType } from '@atom/types/form';
import { Media } from '@atom/types/media';
import { convertDateToMillisGMTMidday } from '@atom/utilities/timeUtilities';

import FileUploadButton from '../FileUploadButton';
import FileUploadTile from '../FileUploadTile';

import classes from '../formInstance.module.css';

interface PassedProps {
  field: FormFieldType;
  media: Media[];
  fieldId: string;
  onChange: (dateMillis: number) => void;
  removeFile: (mediaId: string, subjectId: string) => void;
  fieldFileUpload: (event: ChangeEvent<HTMLInputElement>) => void;
  renameMedia: (mediaId: string, subjectId: string, name: string) => void;
  value: any;
  isEditable: boolean;
  isUploadDisabled: boolean;
}

type Props = PassedProps;

const DatePickerField = ({
  field,
  fieldId,
  onChange,
  value,
  removeFile,
  isEditable,
  media,
  fieldFileUpload,
  isUploadDisabled,
  renameMedia,
}: Props) => {
  const dateValue = value !== '' ? value : null;
  const medium = media.filter((med: Media) => med.fieldId === fieldId);

  const onDateChange = (date: Date) => {
    if (!date) {
      onChange(null);
    } else {
      onChange(convertDateToMillisGMTMidday(date));
    }
  };

  return (
    <div className={classes.fieldBlock}>
      <div
        className={clsx(
          classes.shortTextfieldContainer,
          field.required && classes.required,
        )}
      >
        <DatePicker
          name={field.type}
          value={dateValue}
          onChange={onDateChange}
          disabled={!isEditable}
          label={field.title}
        />
        {field.fileUpload && (
          <FileUploadButton
            onChange={fieldFileUpload}
            isUploadDisabled={!isEditable || isUploadDisabled}
          />
        )}
      </div>
      <div className={classes.fieldDescription}>{field.description}</div>
      <div className={classes.fileTileContainer}>
        {medium.map((mediaItem: Media) => (
          <CarouselWrapper
            media={media}
            selectedMediaId={mediaItem.id}
            removeFile={removeFile}
            subjectId={fieldId}
            renameMedia={renameMedia}
            canUpdateMedia={isEditable}
            canDeleteMedia={isEditable}
          >
            <FileUploadTile key={mediaItem.id} media={mediaItem} />
          </CarouselWrapper>
        ))}
      </div>
    </div>
  );
};

export default DatePickerField;
